import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  ConfigurationItemPicker,
  ConfigurationItemPickerFieldSchema,
} from './ConfigurationItemPickerExtension';
import { validateConfigurationItem } from './validator';

export const configurationItemPickerField = {
  name: 'ConfigurationItemPicker',
  component: ConfigurationItemPicker,
  schema: ConfigurationItemPickerFieldSchema,
  validation: validateConfigurationItem,
};

export const ConfigurationItemPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    ...configurationItemPickerField,
    schema: ConfigurationItemPickerFieldSchema.schema,
  }),
);
